import Toastify from './Toastify';
import CONFIG from '../config';

const BASE_URL = CONFIG.BASE;

const URLS = {
    LOGIN: '/api/reporter/login',
    SIGNUP: '/api/reporter/signup',
    ACCOUNTS: '/api/reporter/accounts',
    CONNECT_ACCOUNT: '/api/reporter/accounts/connect',
    SYNC_ACCOUNT: '/api/reporter/accounts/sync',
    DISCONNECT_ACCOUNT: '/api/reporter/accounts/disconnect',
    MONITOR: '/api/reporter/leads/monitor',
    LEADS: '/api/reporter/leads',
    COMPANY_LEADS: '/api/reporter/companies',
    COMPANY_MONITOR: '/api/reporter/companies/monitor',
    WEBHOOKS: '/api/reporter/webhooks',
    ALERTS: '/api/reporter/alerts',
    SUPERLOGIN: '/api/reporter/superLogin',
    AICSV: '/api/reporter/aicsv',
};

export default class APIUrls {
    public static getURL = (key: keyof typeof URLS): string => {
        if (URLS[key]) {
            return `${BASE_URL}${URLS[key]}`;
        }
        const msg = `Cant find url ${key}`;
        Toastify.show(msg);
        throw Error(msg);
    };
}
